<div class="inline-flex" [pTooltip]="tooltip | i18next" tooltipPosition="top">
  <p-button
    [styleClass]="spacing + ' ' + 'p-button-' + (type ?? '') + ' ' + styleClass"
    [icon]="icon"
    (onClick)="command($event, rowData)"
    [disabled]="disabled ? disabled(rowData) : false"
    [loading]="loading"
  ></p-button>
</div>
